import React, { useEffect, useState } from "react";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialInput from "../../../../components/MaterialInput";
import {
  CardContent,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Switch,
} from "@mui/material";
import MaterialButton from "../../../../components/MaterialButton";
import { useNavigate } from "react-router-dom";
import MaterialSelect from "../../../../components/MasterSelect";
import { fetchData } from "../../../../services";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import DropDownConfig from "../../../Utils/DropDownConfig";

export const GeneralDiscountForm = ({ onsubmit, editDiscountData }) => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const [discountData, setDiscountData] = useState({
    // discount information
    name: "",
    maxLimit: null,
    description: "",
    productId: "",
    policyTypeId: "",
    autoApply: true,
    mandatory: true,
    active: true,

    // discount information status
    nameStatus: "unchecked",
    maxLimitStatus: "unchecked",
    descriptionStatus: "unchecked",
  });
  const [productOptions, setProductOptions] = useState([]);
  const [policyTypeOptions, setPolicyTypeOptions] = useState([]);

  useEffect(() => {
    if (editDiscountData) {
      setDiscountData(editDiscountData);
    }
  }, [editDiscountData]);

  //dropdown apis
    useEffect(() => {
  
      //dropdown apis for form
      const fetchDropdowns = async () => {
        setCircleLoading(true);
        try {
        const [productResponse, policyTypeResponse] = await Promise.all([
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),  //code passing for product
          fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalPolicyType}`)  //code passing for policy type
        ]);
  
          if (productResponse?.success) {
            setProductOptions(
              productResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
              })) || []
            );
          }
  
          if (policyTypeResponse?.success) {
            setPolicyTypeOptions(
              policyTypeResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
              })) || []
            );
          }
        } catch (error) {
          console.error("Error fetching dropdown data:", error);
          showSnackbar("Error fetching Dropdown data","warning");
        } finally {
          setCircleLoading(false);
        }
      };
  
      fetchDropdowns();
    }, []);

  const handleDiscountDataChange = (event, selectEvent) => {
    let discountState = { ...discountData };

    const changeAllowed = true;
    
    if(event?.target === undefined && selectEvent){
      switch(selectEvent.name){
        case "productId": {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event?.trim?.())) {
            discountState[selectEvent.name + "Status"] = "success";
            } else {
            discountState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }

            break;
        }

        case "policyTypeId": {
            const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

            if (alphaNLenghthRegex.test(event?.trim?.())) {
            discountState[selectEvent.name + "Status"] = "success";
            } else {
            discountState[selectEvent.name + "Status"] =
                event === "" ? "unchecked" : "error";
            }

            break;
        }
            
        default: {
            
            discountState[selectEvent.name] = event;
            discountState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
            break;
        }
      }
      discountState[selectEvent.name] = event;
    }
    else if (event && event.target) {
      switch (event.target.name) {
        case "name":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              discountState[event.target.name + "Status"] = "success";
            } else {
              discountState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "maxLimit":
          {
            const alphaNLenghthRegex = new RegExp("^([0-9]{1,20})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              discountState[event.target.name + "Status"] = "success";
            } else {
              discountState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "description":
          {
            const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{2,100})$");

            if (alphaNLenghthRegex.test(event.target.value?.trim())) {
              discountState[event.target.name + "Status"] = "success";
            } else {
              discountState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "autoApply":
          {
            const value = event.target.value;
            discountState[event.target.name] = value;
          }
          break;

        case "mandatory":
          {
            const value = event.target.value;
            discountState[event.target.name] = value;
          }
          break;

        case "active":
          {
            const value = event.target.value;
            discountState[event.target.name] = value;
          }
          break;

        default:
          break;
      }

      if (changeAllowed) {
        discountState[event.target.name] = event.target.value;
      }
    }
    setDiscountData(discountState);
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      discountData.nameStatus === "success" &&
      discountData.maxLimitStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleSubmit = () => {
    if (checkAllFields()) {
      onsubmit(discountData);
    }
  };

  return (
    <div>
      <CardContent sx={{ minHeight: "65vh" }}>
        <MaterialBox>
          <Grid container spacing={1}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Discount Name*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="name"
                placeholder="eg. Discount name"
                value={discountData.name}
                onChange={handleDiscountDataChange}
                error={discountData.nameStatus === "error" ? true : false}
                success={discountData.nameStatus === "success" ? true : false}
              />
              {discountData.nameStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Name should be maximum 20 characters long and can contain
                    only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Discount Max Limit*
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                type="number"
                name="maxLimit"
                placeholder="eg. 100"
                value={discountData.maxLimit}
                onChange={handleDiscountDataChange}
                error={discountData.maxLimitStatus === "error" ? true : false}
                success={
                  discountData.maxLimitStatus === "success" ? true : false
                }
              />
              {discountData.maxLimitStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Limit should be maximum 20 characters long and can contain
                    only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Product*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="productId"
                value={discountData.productId}
                options={productOptions}
                onChange={handleDiscountDataChange}
                error={discountData.productIdStatus === "error" ? true : false}
                success={
                  discountData.productIdStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Policy Type*
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="policyTypeId"
                value={discountData.policyTypeId}
                options={policyTypeOptions}
                onChange={handleDiscountDataChange}
                error={discountData.policyTypeIdStatus === "error" ? true : false}
                success={
                  discountData.policyTypeIdStatus === "success" ? true : false
                }
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Description
                </MaterialTypography>
              </MaterialBox>
              <MaterialInput
                name="description"
                placeholder="eg. discount description"
                value={discountData.description}
                onChange={handleDiscountDataChange}
                error={
                  discountData.descriptionStatus === "error" ? true : false
                }
                success={
                  discountData.descriptionStatus === "success" ? true : false
                }
                multiline
                rows={3}
              />
              {discountData.descriptionStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Description should be maximum 100 characters long and can
                    contain only alphabets
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Auto Apply
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="autoApply"
                    checked={discountData.autoApply}
                    onChange={(event) =>
                      handleDiscountDataChange({
                        target: {
                          name: "autoApply",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {discountData?.autoApply ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Mandatory
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="mandatory"
                    checked={discountData.mandatory}
                    onChange={(event) =>
                      handleDiscountDataChange({
                        target: {
                          name: "mandatory",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {discountData?.mandatory ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 2 }}>
              <MaterialBox>
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Active
                </MaterialTypography>
              </MaterialBox>
              <FormControlLabel
                control={
                  <Switch
                    name="active"
                    checked={discountData.active}
                    onChange={(event) =>
                      handleDiscountDataChange({
                        target: {
                          name: "active",
                          value: event.target.checked,
                        },
                      })
                    }
                    color="primary"
                  />
                }
                label={
                  <MaterialTypography variant="caption" fontWeight="bold">
                    {discountData?.active ? "Yes" : "No"}
                  </MaterialTypography>
                }
                sx={{ marginLeft: 0 }}
              />
            </Grid>
          </Grid>
        </MaterialBox>
      </CardContent>
      <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <MaterialButton
          sx={{ m: 2 }}
          variant="outlined"
          color="dark"
          onClick={() => {
            navigate("/general-master/general-discount");
          }}
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          sx={{ m: 2 }}
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleSubmit}
        >
          Submit
        </MaterialButton>
      </MaterialBox>
    </div>
  );
};
